import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { getIsSomeMenuVisbleSelector } from '@web-common/state/reducer/privilegeReducer';
import { getStaffInfoAsync } from '@web-common/state/reducer/aiStaffReducer';
import { initAiTeamState } from '@web-common/state/reducer/aiTeamReducer';
import { navigate } from 'gatsby';
export const useAiStaffInfo = () => {
    const appDispatch = useAppDispatch();
    const { menuReady } = useAppSelector(state => state.privilegeReducer);
    const aiStaffMenuVisibleFromRedux = useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['PERSONAL_AI_STAFF']));
    const aiStaffMenuVisible = menuReady && aiStaffMenuVisibleFromRedux;
    const aiTeamMenuVisibleFromRedux = useAppSelector(state => getIsSomeMenuVisbleSelector(state.privilegeReducer, ['PERSONAL_AI_TEAM']));
    const aiTeamMenuVisible = menuReady && aiTeamMenuVisibleFromRedux;
    const aiMenuVisible = aiStaffMenuVisible || aiTeamMenuVisible;
    const { staffInfo } = useAppSelector(state => state.aiStaffReducer);
    const { teamInfo } = useAppSelector(state => state.aiTeamReducer);
    const aiInfo = teamInfo || staffInfo;
    const navigateToAiPage = () => {
        if (aiStaffMenuVisible) {
            return navigate('/#aiStaff?page=aiStaff');
        }
        if (aiTeamMenuVisible) {
            return navigate('/#aiTeam?page=aiTeam');
        }
    };
    const initAiStaffInfo = () => appDispatch(getStaffInfoAsync({ showLoading: false, config: { toastError: false } }))
        .unwrap()
        .catch(() => null);
    const initAiTeamInfo = () => appDispatch(initAiTeamState({ showLoading: false, config: { toastError: false } }))
        .unwrap()
        .catch(() => null);
    const initAiStaffOrTeamInfo = () => {
        if (aiStaffMenuVisible) {
            return initAiStaffInfo();
        }
        if (aiTeamMenuVisible) {
            return initAiTeamInfo();
        }
        return Promise.resolve(null);
    };
    return {
        aiStaffMenuVisible,
        aiTeamMenuVisible,
        aiMenuVisible,
        staffInfo,
        teamInfo,
        aiInfo,
        initAiStaffInfo,
        initAiTeamInfo,
        initAiStaffOrTeamInfo,
        navigateToAiPage,
    };
};
